import { useState } from "react";
import _ from "lodash";
import { useTranslation } from "react-i18next";
import { Typography, useTheme } from "@mui/material";
import { patchInvestigation } from "../../../../../../apis";
import { useConstants } from "../../Main/useConstants";
import { ModalContainer } from "../../components/ModalContainer"
import { initResources } from "../schemas";
import { AddResource } from "../AddResource";

export const CreateResourceFromAnywhere = ({
  show,
  onHide,
  investigation,
  setInvestigation,
}) => {

  const { functions: { askUpdateInvestigationContext } } = useConstants();
  const [t] = useTranslation("investigation");
  const theme = useTheme();

  const [resources] = useState(investigation?.resources ?? _.cloneDeep(initResources));
  const [isLoading, setIsLoading] = useState(false);

  const handleSaveResources = async (newResources) => {
    setIsLoading(true);
    const objToSave = {
      folder: {
        resources: newResources,
      },
    };
    try {
      await patchInvestigation(investigation.alias, objToSave);
      const updatedInvestigation = { ...investigation, resources: newResources };
      setInvestigation(updatedInvestigation);
      askUpdateInvestigationContext(updatedInvestigation);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <ModalContainer show={show} onHide={onHide}>
      <Typography fontWeight={700} fontSize={28} color={theme.palette.ethicsBlue.main}>
        {t("activityPlan.create_resource")}
      </Typography>
      <Typography fontSize={16} color="oxfordBlue" >
        {t("activityPlan.create_resource_description")}
      </Typography>
      <div className="hr-div"></div>
      <AddResource
        resources={resources}
        handleSaveResources={handleSaveResources}
        isLoading={isLoading}
        setIsEditing={onHide}
        justForm={true}
      />
    </ModalContainer>
  )
}
